import { debounce } from 'lodash';
import { useEffect, useRef } from 'react';

/**
 * A debounced useEffect hook.
 *
 * @param effect Function to run after the debounce delay
 * @param deps Dependency array like in useEffect
 * @param delay Delay in milliseconds
 */
export function useDebouncedEffect(effect: () => void, deps: any[], delay: number) {
  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    const handler = debounce(() => {
      effectRef.current();
    }, delay);

    handler();

    return () => {
      handler.cancel();
    };
  }, [...deps, delay]);
}
